/**
 * Ссылки на Конспект в шапке и подвале ingdg.com.
 *
 * Отдельный маленький модуль, а не `konspekt-ingdg.ts`: шапка и подвал —
 * клиентские компоненты на каждой странице, и тянуть в их бандл тексты
 * посадочной на трёх языках незачем. Совпадение языков с посадочной
 * сверяет тест.
 */

/** Языки, на которых у ingdg.com есть посадочная Конспекта. */
export const JAZYKI_KONSPEKTA_INGDG: readonly string[] = ['en', 'es', 'sr', 'ru'];

export const PUT_KONSPEKTA_INGDG = '/tools/konspekt';

/**
 * Покупка лицензии на самом ingdg.com (владелец 04.10.2026: переход с
 * ingdg на aisearch.tech для оплаты — «бред»). API лицензий выбирается по
 * домену запроса, на ingdg.com это api.ingdg.com: тот же каталог, USDT/BTC.
 */
export const PUT_POKUPKI_KONSPEKTA = '/pricing/license/konspekt';

/** Полный адрес покупки — для кнопок вне next-intl и для разметки Offer. */
export function adresPokupkiKonspekta(locale: string): string {
  return `https://ingdg.com${locale === 'en' ? '' : `/${locale}`}${PUT_POKUPKI_KONSPEKTA}`;
}

/** Раздел программ ingdg.com: Конспект и диктовка. */
export const PUT_PROGRAMM_INGDG = '/software';

/**
 * Общая страница инструментов ingdg.com (ТЗ Seo-marketing 10.10.2026):
 * из Google за четыре месяца один клик, отдельные инструменты находятся
 * плохо, а страницы, которая собирает их вместе, не было.
 */
export const PUT_KATALOGA_INGDG = '/tools';

/** Ссылка на каталог в подвале и на страницах инструментов. */
export const PODPIS_VSE_INSTRUMENTY: Record<string, string> = {
  en: 'All tools',
  es: 'Todas las herramientas',
  ru: 'Все инструменты',
  sr: 'Svi alati',
};

/** Звено хлебных крошек, ведущее на каталог. */
export const KROSHKA_INSTRUMENTY: Record<string, string> = {
  en: 'Tools',
  es: 'Herramientas',
  ru: 'Инструменты',
  sr: 'Alati',
};

/** Диктовка «для работы» на ingdg.com: en, sr и ru (`diktovka-ingdg.ts`). */
export const PUT_DIKTOVKI_INGDG = '/tools/dictation';
export const JAZYKI_DIKTOVKI_SSYLKI: readonly string[] = ['en', 'sr', 'ru'];
